var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccBeauty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Beauty",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8399",
    "data-name": "Rectangle 8399",
    width: 28,
    height: 28,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35260",
    "data-name": "Group 35260",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35902",
    "data-name": "Path 35902",
    d: "M12.423,9.189,10.9,10.715A.864.864,0,0,1,9.675,9.494L11.2,7.967a.929.929,0,0,1,1.221,0,.793.793,0,0,1,.1,1.117.73.73,0,0,1-.1.1",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35903",
    "data-name": "Path 35903",
    d: "M15.4,10.41,12.04,13.77a.864.864,0,0,1-1.221-1.221L14.178,9.19a.929.929,0,0,1,1.221,0,.793.793,0,0,1,.1,1.117.73.73,0,0,1-.1.1",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35904",
    "data-name": "Path 35904",
    d: "M5.5,22.971h17a2.882,2.882,0,0,1-2.882,2.882H8.381A2.882,2.882,0,0,1,5.5,22.971Z",
    fill: "#b3b5c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35905",
    "data-name": "Path 35905",
    d: "M13.917,2.773a9.431,9.431,0,0,0-9.281,9.574,9.616,9.616,0,0,0,4.878,8.426H18.32A9.616,9.616,0,0,0,23.2,12.344a9.431,9.431,0,0,0-9.281-9.571M14,19.232a7.085,7.085,0,1,1,7.085-7.085A7.085,7.085,0,0,1,14,19.232h0",
    fill: "#b3b5c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccBeauty);
export default __webpack_public_path__ + "static/media/mcc_beauty.07d9e3456dd85ca7e854bdf035566fb8.svg";
export { ForwardRef as ReactComponent };